import { render, staticRenderFns } from "./ViewOrderRefund.vue?vue&type=template&id=67b7d6bf&scoped=true&"
import script from "./ViewOrderRefund.vue?vue&type=script&lang=js&"
export * from "./ViewOrderRefund.vue?vue&type=script&lang=js&"
import style0 from "./ViewOrderRefund.vue?vue&type=style&index=0&id=67b7d6bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b7d6bf",
  null
  
)

export default component.exports